"use strict";

function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
var __awaiter = void 0 && (void 0).__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMsalClient = exports.get = void 0;
var msal_browser_1 = require("@azure/msal-browser");
var config_1 = __importDefault(require("../../../build-babel/auth/client/config"));
var handler_1 = __importDefault(require("../../../build-babel/auth/response/handler"));
var error_1 = __importDefault(require("../../../build-babel/auth/response/error"));
var session_1 = require("../../../build-babel/session");
var removeLocalStorageCache = function removeLocalStorageCache() {
  // ITWMDIO-2622: temporary fix
  for (var i = 0; i < localStorage.length; i++) {
    var localStorageItemKey = localStorage.key(i);
    if (localStorageItemKey && localStorageItemKey.indexOf('b2c_1a') !== -1) {
      localStorage.removeItem(localStorageItemKey);
    }
  }
};
var enableLoginLogoutSyncAcrossTabs = function enableLoginLogoutSyncAcrossTabs(msalClient) {
  //enable account storage event
  msalClient.enableAccountStorageEvents();
  msalClient.addEventCallback(function (message) {
    if (message.eventType === msal_browser_1.EventType.ACCOUNT_REMOVED) {
      (0, session_1.removeSession)(window.location.href);
    }
  });
};
var get = function get(interactiveFunction) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee() {
    var msalClient;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          _context.n = 1;
          return (0, exports.getMsalClient)();
        case 1:
          msalClient = _context.v;
          msalClient.handleRedirectPromise().then(function (authResult) {
            (0, handler_1["default"])(msalClient, authResult);
            if (interactiveFunction) {
              interactiveFunction(msalClient, authResult);
            }
          })["catch"](function (error) {
            // id token
            removeLocalStorageCache();
            // refresh token
            removeLocalStorageCache();
            msalClient.clearCache();
            (0, error_1["default"])(error);
          });
          return _context.a(2, msalClient);
      }
    }, _callee);
  }));
};
exports.get = get;
var getMsalClient = function getMsalClient() {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator().m(function _callee2() {
    var config, msalClient;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          config = (0, config_1["default"])();
          msalClient = new msal_browser_1.PublicClientApplication(config);
          _context2.n = 1;
          return msalClient.initialize();
        case 1:
          enableLoginLogoutSyncAcrossTabs(msalClient);
          return _context2.a(2, msalClient);
      }
    }, _callee2);
  }));
};
exports.getMsalClient = getMsalClient;
//# sourceMappingURL=index.js.map